<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-21 10:37:19
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Approval\ApprovalProcess\viewClaimApprovalProcess.vue
 * @最后编辑: Please set LastEditors
 * @最后修改时间: 2022-05-05 11:30:43
-->
<template>
  <ContentLayout
    :title="
      iSEdited
        ? $t('label_essweb_myClaimApplication_form_editTitle')
        : $t('label_essweb_approvalProcess_form_claimTitle')
    "
    widthClass="max-1000"
    backgroundClass="transparent"
    pad="0"
  >
    <!--  :editBtn="
      (!iSEdited &&
        Number(ClaimApplicationData.is_match) == 1 &&
        ClaimApplicationData.field_uuid != null) ||
      (!iSEdited &&
        Number(ClaimApplicationData.is_match) == 1 &&
        Number(ClaimApplicationData.is_application_sequence) == 1)
    " -->
    <template v-slot:nav-actions>
      <v-tooltip
        bottom
        v-if="
          can_be_cancel && Number(ClaimApplicationData.approval_status) == 1
        "
      >
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            class="primary mr-4"
            color="white"
            v-on="on"
            width="40"
            height="40"
            @click.stop="toCancel"
          >
            <svg-icon size="24" fill="white" iconClass="application-cancel" />
          </v-btn>
        </template>
        <span>{{ $t("label_essweb_form_tools_cancelBtnLabel") }}</span>
      </v-tooltip>
      <approvalTools
        v-if="ClaimApplicationData && ClaimApplicationData['flow_status'] == 1"
        :curUuid="ClaimApplicationData['uuid']"
        :staff_uuid="curStaff"
        :flag="ClaimApplicationData['cancel_flag']"
        :data_type="ClaimApplicationData['data_type']"
        :final_node="Number(ClaimApplicationData['is_final_task_node'])"
        :matched="Number(ClaimApplicationData['is_match']) ? true : false"
        :canRevoke="Number(ClaimApplicationData['is_allow_revoke'])"
        :canRollback="Number(ClaimApplicationData['is_allow_rollback'])"
        :canForward="Number(ClaimApplicationData['is_allow_forward'])"
        @back="onBack"
        @forward="onForward"
        @approval="onApproval"
        @reject="onReject"
      />
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <ApprovalTriger
        v-if="ClaimApplicationData"
        :bg-color="ClaimApplicationData.approval_bg_color"
        :slide-color="ClaimApplicationData.approval_tint_color"
        :triger="
          ClaimApplicationData.approval_status == 1 ||
          ClaimApplicationData.approval_status == 2
        "
        @triger="
          ClaimApplicationData.approval_status == 1 ||
          ClaimApplicationData.approval_status == 2
            ? $toPage(
                '/admin/approval-process/claim-detail/' +
                  $route.params.params +
                  '/approval-detail/' +
                  $route.params.params
              )
            : null
        "
      >
        <template v-slot:time>
          {{
            $getDateTime(
              ClaimApplicationData.operate_utc_datetime,
              "YYYY/MM/DD HH:mm"
            )
          }}
        </template>
        <template v-slot:status>
          {{ $getCommonLangValue(ClaimApplicationData.status_detail) }}
        </template>
      </ApprovalTriger>
      <Taber
        :curTab="curTab"
        @change="(tab) => (curTab = tab)"
        :items="taber"
        special
        backgroundColor="transparent"
        contentBackground="mrc-grey pa-0"
      >
        <template v-slot:content-1>
          <Section isStart>
            <v-form lazy-validation ref="form">
              <v-row>
                <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                  <normalInputTextFiled
                    :disabled="true"
                    :readonly="!iSEdited"
                    :filled="iSEdited"
                    :value="ClaimApplicationData.swift_number"
                    :label="
                      $t(
                        'label_essweb_myClaimApplication_form_swiftNumberLabel'
                      )
                    "
                    dense
                  />
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                  <normalInputTextFiled
                    :disabled="true"
                    :readonly="!iSEdited"
                    :filled="iSEdited"
                    :value="
                      $getDateTime(
                        ClaimApplicationData.submission_utc_datetime,
                        'YYYY/MM/DD HH:mm'
                      )
                    "
                    :label="
                      $t('label_essweb_myClaimApplication_form_createOnLabel')
                    "
                    dense
                  />
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                  <normalInputTextFiled
                    :disabled="true"
                    :readonly="!iSEdited"
                    :filled="iSEdited"
                    :value="
                      $getCommonLangValue(ClaimApplicationData.claim_type_name)
                    "
                    :label="
                      $t('label_essweb_myClaimApplication_form_claimTypeLabel')
                    "
                    dense
                  />
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                  <AutoComplete
                    label="label_essweb_myClaimApplication_form_applicantLabel"
                    v-model="user"
                    :readonly="!iSEdited"
                    :filled="iSEdited"
                    :small-chips="!iSEdited"
                    disabled
                    avatar
                    chips
                    :items="users"
                    item-value="uuid"
                    item-text="preferred_name"
                  >
                    <template v-slot:selection.avatar="{ data }">
                      <StaffAvatar
                        left
                        :small="!iSEdited"
                        :isTemp="data.item.is_temp"
                        :src="data.item.staff_avatar"
                        :staff_name="data.item.preferred_name"
                      />
                    </template>
                    <template v-slot:selection="{ data }">
                      {{ $getCommonLangValue(data.item.preferred_name) }}
                    </template>
                  </AutoComplete>
                </v-col>
              </v-row></v-form
            >
          </Section>
          <Section :iSEdited="iSEdited" isEnd>
            <v-form lazy-validation ref="form2">
              <v-row>
                <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                  <normalInputTextFiled
                    :readonly="!iSEdited"
                    :disabled="
                      !(
                        ClaimApplicationData.field_uuid.indexOf(
                          'claim_form_name'
                        ) != -1
                      )
                    "
                    :filled="iSEdited"
                    v-model="ClaimApplicationData.claim_form_name"
                    :rules="$GetRules(['_Require_Rules'], [null])"
                    :label="
                      $t(
                        'label_essweb_myClaimApplication_form_claimformTitleLabel'
                      )
                    "
                  />
                </v-col>
                <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                  <normalInputTextFiled
                    :readonly="!iSEdited"
                    :disabled="
                      !(
                        ClaimApplicationData.field_uuid.indexOf(
                          'claim_form_description'
                        ) != -1
                      )
                    "
                    :filled="iSEdited"
                    v-model="ClaimApplicationData.claim_form_description"
                    :label="
                      $t(
                        'label_essweb_myClaimApplication_form_descriptionLabel'
                      )
                    "
                  />
                </v-col>
              </v-row>
            </v-form>
          </Section>
        </template>
        <template v-slot:content-2>
          <v-card class="pa-0 elevation-0 primary lighten-4 rounded-lg">
            <v-card-text>
              <div class="text-left text-h6 text--primary">
                {{ $t("label_essweb_ClaimRecord_form_claimTotalAmountLabel") }}
              </div>
              <div class="text-right text-h5 text--primary">
                {{ currency_code }}
                {{
                  $get_thousand_num(parseFloat(Number(total_amount).toFixed(4)))
                }}
              </div>
            </v-card-text>
          </v-card>
          <Section>
            <Tabler :headers="headers" :items="desserts" border>
              <template v-slot:item.type="{ item }">
                {{ $getCommonLangValue(item.claim_item_type_name) }}
              </template>
              <template v-slot:item.name="{ item }">
                {{ $getCommonLangValue(item.claim_item_name) }}
              </template>
              <template v-slot:item.actual_amount="{ item }">
                {{ item.actual_currency_code }}
                {{
                  $get_thousand_num(
                    parseFloat(Number(item.actual_amount).toFixed(4))
                  )
                }}
              </template>
              <template v-slot:item.claim_amount="{ item }">
                {{ item.claim_currency_code }}
                {{
                  $get_thousand_num(
                    parseFloat(Number(item.claim_amount).toFixed(4))
                  )
                }}
              </template>
              <template v-slot:item.approval_amount="{ item }">
                {{ currency_code }}
                {{
                  $get_thousand_num(
                    parseFloat(Number(item.approved_amount).toFixed(4))
                  )
                }}
              </template>

              <template v-slot:item.action="{ item }">
                <v-btn icon @click="toViewItem(item.uuid)" v-if="!iSEdited">
                  <svg-icon
                    size="24"
                    fill="currentColor"
                    iconClass="viewDetail"
                  />
                </v-btn>
                <v-btn
                  icon
                  @click="toEditItem(item.uuid)"
                  v-if="
                    (iSEdited &&
                      Number(ClaimApplicationData.is_match) == 1 &&
                      Number(ClaimApplicationData.is_application_sequence) ==
                        1) ||
                    (iSEdited &&
                      Number(ClaimApplicationData.is_match) == 1 &&
                      ClaimApplicationData['field_uuid'].length > 0)
                  "
                >
                  <span class="material-icons-round">edit</span>
                </v-btn>
                <!-- <v-btn
                    icon
                    v-if="iSEdited"
                    @click="
                      $confirmDo(
                        $t(
                          'label_essweb_myClaimApplication_form_step_claimItemLabel'
                        )
                      ).then((res) => {
                        res ? toDeleteItem(item.uuid) : null;
                      })
                    "
                  >
                    <span class="material-icons-round">delete</span>
                  </v-btn> -->
              </template>
              <!-- <template v-slot:footer>
                  <v-divider></v-divider>
                  <v-btn
                    text
                    v-if="iSEdited"
                    small
                    color="primary"
                    class="text-capitalize mt-2"
                    @click="toNewMapping"
                  >
                    {{
                      $t(
                        "label_essweb_myClaimApplication_form_addClaimItemBtnLabel"
                      )
                    }}<span class="material-icons-round">add</span>
                  </v-btn>
                </template> -->
            </Tabler>
          </Section>
        </template>
      </Taber>
    </template>
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited && curTab == 'tab-1'"
        :saveBtn="curTab == 'tab-1'"
        @save="toSave"
        @cancel="toBack"
      />
    </template>
    <!-- content -->

    <template v-slot:tools-main>
      <!-- <newClaimItem
        :show="showNewClaim"
        :curTypeUuid="$route.params.typeid"
        @close="showNewClaim = false"
        @onNew="
          (obj) => {
            if (
              Number(obj['claim_amount']) + Number(total_amount) >
              Number(claim_total_amount)
            ) {
              $confirmWarn(
                $t('message_essweb_myClaimApplication_form_overBalanceTitle'),
                $t('message_essweb_myClaimApplication_form_overBalanceLabel')
              ).then((res) => {
                if (res) {
                  onNewItem(obj);
                }
              });
            } else {
              onNewItem(obj);
            }
          }
        "
        :staff_uuid="curAppInfo['user']['user_id']"
      /> -->
      <!-- <editClaimItem
        :show="showEditClaimItem"
        :curTypeUuid="curTypeUuid"
        @close="
          showEditClaimItem = false;
          curUuid = null;
        "
        control
        :field_args="ClaimApplicationData.field_uuid"
        @onSave="onSaveItem"
        :staff_uuid="curAppInfo['user']['user_id']"
        :curUuid="curUuid"
      /> -->
      <viewClaimItem
        :show="showViewClaimItem"
        :isAllowViewAttachments="1"
        :curTypeUuid="curTypeUuid"
        @close="
          showViewClaimItem = false;
          curUuid = null;
        "
        :staff_uuid="curAppInfo['user']['user_id']"
        :curUuid="curUuid"
      />
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
import approvalTools from "@/Page/EssAdmin/Approval/ApprovalProcess/components/approvalTools";
// import editClaimItem from "@/Page/Ess/Claim/ClaimApplication/components/editClaimItem";
// import newClaimItem from "@/Page/Ess/Claim/ClaimApplication/components/newClaimItem";
import viewClaimItem from "@/Page/Ess/Claim/ClaimApplication/components/viewClaimItem";
export default {
  name: "viewClaimApprovalProcess",
  components: {
    approvalTools,
    // editClaimItem,
    // newClaimItem,
    viewClaimItem,
  },
  computed: {
    ...mapGetters(["companyLang", "AppInfo"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
    total_amount() {
      let amount = 0;
      this.desserts.map((item) => {
        amount += Number(item.approved_amount);
      });
      return amount;
    },
  },
  data() {
    return {
      taber: [
        "label_essweb_ClaimRecord_form_tab_formInfoLabel",
        "label_essweb_ClaimRecord_form_tab_claimItemLabel",
      ],
      curStaff: null,
      curUuid: null,
      iSEdited: false,
      showViewClaimItem: false,
      users: [],
      showEditClaimItem: false,
      user: null,
      can_be_cancel: 0,
      showSender: false,
      showNewClaim: false,
      curTab: "tab-1",
      showDelete: false,
      showClaimCancelReason: false,
      currency_code: "",
      propertys: {
        is_show_claim_reason: { value: 0 },
      },
      curTypeUuid: "",
      claim_total_amount: 0,
      ClaimApplicationData: {
        claim_form_name: "",
        is_match: 0,
        field_uuid: [],
        approval_status: -1,
        is_allow_revoke: 0,
        is_allow_revoke: 0,
        is_allow_rollback: 0,
        flow_status: 0,
        claim_form_description: "",
      },
      headers: [
        {
          text: "label_essweb_ClaimRecord_form_dialog_claimItemTypeLabel",
          value: "type",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimRecord_form_dialog_claimItemNameLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimRecord_form_dialog_actualAmountLabel",
          value: "actual_amount",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimRecord_form_dialog_claimAmountLabel",
          value: "claim_amount",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_ClaimRecord_form_dialog_approvalAmountLabel",
          value: "approval_amount",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      page_params: null,
    };
  },
  watch: {
    curTypeUuid(val) {
      if (val) {
        this.getProperty();
        this.getClaimBalanceDetail(val);
      }
    },
  },
  mounted() {
    this.page_params = JSON.parse(this.$aesDecrypt(this.$route.params.params)); //解密参数
    this.curStaff = this.curAppInfo["user"]["user_id"];
    this.getDetail();
    this.getClaimItems();
  },
  methods: {
    toCancel: function () {
      const that = this;
      this.$confirmWarn(
        this.$t("message_essweb_myClaimApplication_form_cancelTitle"),
        this.$t("message_essweb_myClaimApplication_form_cancelLabel")
      ).then((res) => {
        if (res)
          that
            .$Request({
              method: "POST",
              table: "x",
              url: "/claim/cancel-claim-application/",
              data: {
                uuid: that.page_params.id,
              },
            })
            .then((res) => {
              that.toBack();
              if (that.iSEdited) that.toBack();
            });
      });
    },
    onReject: function (comments = "") {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_tasks",
        url: "/approval/push/",
        data: {
          uuid: this.page_params.id,
          data_type: 2,
          business_action: "terminate",
          cancel_flag: this.ClaimApplicationData.cancel_flag,
          operate_comment: comments,
        },
      }).then((res) => {
        that.$showMessage({
          type: "success",

          text: that.$t(
            "message_essweb_approvalApplication_form_reject_rejectSuccessLabel"
          ),
        });
        that.$toBack();
      });
    },
    onApproval: function (comments = "", sender) {
      const that = this;
      let data = {
        uuid: this.page_params.id,
        data_type: 2,
        business_action: "send",
        cancel_flag: this.ClaimApplicationData.cancel_flag,
        operate_comment: comments,
      };
      if (sender.length != 0) data["sender_uuid"] = sender.join(",");
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_tasks",
        url: "/approval/push/",
        data: data,
      }).then((res) => {
        that.$showMessage({
          type: "success",

          text: that.$t(
            "message_essweb_approvalApplication_form_send_approvalSuccessLabel"
          ),
        });
        that.$toBack();
      });
    },
    onForward: function (sender, node, comments = "") {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_tasks",
        url: "/approval/push/",
        data: {
          uuid: this.page_params.id,
          data_type: 2,
          business_action: "forward",
          cancel_flag: this.ClaimApplicationData.cancel_flag,
          sender_uuid: sender,
          business_action_status: node == 0 ? 4 : 3,
          operate_comment: comments,
        },
      }).then((res) => {
        that.$showMessage({
          type: "success",

          text: that.$t(
            "message_essweb_approvalApplication_form_forward_forwardSuccessLabel"
          ),
        });
        that.$toBack();
      });
    },
    onBack: function (sender, comments = "") {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_tasks",
        url: "/approval/push/",
        data: {
          uuid: this.page_params.id,
          data_type: 2,
          cancel_flag: this.ClaimApplicationData.cancel_flag,
          business_action: "back",
          business_action_status: sender == 0 ? 1 : 2,
          operate_comment: comments,
        },
      }).then((res) => {
        that.$showMessage({
          type: "success",

          text: that.$t(
            "message_essweb_approvalApplication_form_back_backSuccessLabel"
          ),
        });
        that.$toBack();
      });
    },
    toBack: function () {
      if (this.iSEdited) {
        this.iSEdited = false;
      } else {
        this.$router.back();
      }
    },
    toSave: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_form_records",
        url: "/claim/update-claim-table/",
        data: {
          uuid: this.page_params.id,
          claim_form_name: this.ClaimApplicationData.claim_form_name,
          claim_form_description:
            this.ClaimApplicationData.claim_form_description,
        },
      }).then((res) => {
        that.toBack();
      });
    },
    toCancel: function () {
      const that = this;
      this.$confirmWarn(
        this.$t("message_essweb_myClaimApplication_form_cancelTitle"),
        this.$t("message_essweb_myClaimApplication_form_cancelLabel")
      ).then((res) => {
        if (res)
          that
            .$Request({
              method: "POST",
              table: "x",
              url: "/claim/cancel-claim-application/",
              data: {
                uuid: that.page_params.id,
              },
            })
            .then((res) => {
              that.toBack();
              if (that.iSEdited) that.toBack();
            });
      });
    },
    getProperty: function () {
      const that = this;
      that
        .$Request({
          method: "POST",
          table: "x",
          url: "/claim/get-claim-type-propertys/",
          data: {
            claim_type_uuid: this.curTypeUuid,
            codes:
              "is_show_balance,is_show_brought_over,is_show_entitlement,is_show_earned,is_show_taken,is_show_pending,is_allow_take_advance,is_allow_take_advance|take_advance_unit,is_show_claim_reason",
          },
        })
        .then((res) => {
          for (let key in res.data) {
            if (res.data[key] == null) {
              res.data[key] = { value: 0 };
            }
          }
          that.propertys = res.data;
        });
    },
    toEditItem: function (uuid) {
      this.curUuid = uuid;
      this.showEditClaimItem = true;
    },
    toNewMapping: function () {
      this.showNewClaim = true;
    },
    onNewItem: function (obj) {
      const that = this;
      this.showNewClaim = false;
      let arr = [];
      if (obj["attachments"])
        obj["attachments"].map((ite) => {
          arr.push(ite.uuid);
        });
      that
        .$Request({
          method: "POST",
          table: "ess_clm_claim_form_record_items",
          url: "/claim/add-claim-item/",
          data: {
            claim_form_record_uuid: this.page_params.id,
            claim_type_uuid: this.curTypeUuid,
            claim_item_type_uuid: obj.claim_item_type_uuid,
            claim_reason_uuid: obj.claim_reason_uuid,
            claim_item_description: obj.claim_item_description,
            claim_item_name: obj.claim_item_name,
            claim_amount: obj.claim_amount,
            claim_currency_uuid: obj.claim_currency_uuid,
            payout_utc_datetime: this.$getTimeValue(
              obj.payout_utc_datetime,
              "claim"
            ),
            receipt_swift_number: obj.receipt_swift_number,
            actual_amount: obj.actual_amount,
            attachment_uuid: arr.join(","),
            actual_currency_uuid: obj.actual_currency_uuid,
            cost_center_uuid: obj.cost_center_uuid,
          },
        })
        .then((res) => {
          that.getClaimItems();
        });
    },
    onSaveItem: function (obj) {
      const that = this;
      this.showEditClaimItem = false;
      this.curUuid = null;
      let arr = [];
      if (obj["attachments"])
        obj["attachments"].map((ite) => {
          arr.push(ite.uuid);
        });
      that
        .$Request({
          method: "POST",
          table: "ess_clm_claim_form_record_items",
          url: "/claim/update-claim-item/",
          data: {
            claim_form_record_uuid: this.page_params.id,
            uuid: obj.uuid,
            claim_item_name: obj.claim_item_name,
            claim_item_description: obj.claim_item_description,
            claim_item_type_uuid: obj.claim_item_type_uuid,
            claim_reason_uuid: obj.claim_reason_uuid,
            payout_utc_datetime: this.$getTimeValue(
              obj.payout_utc_datetime,
              "claim"
            ),
            receipt_swift_number: obj.receipt_swift_number,
            attachment_uuid: arr.join(","),
            actual_amount: obj.actual_amount,
            approved_amount: obj.approved_amount,
            actual_currency_uuid: obj.actual_currency_uuid,
            claim_amount: obj.claim_amount,
            claim_currency_uuid: obj.claim_currency_uuid,
            cost_center_uuid: obj.cost_center_uuid,
          },
        })
        .then((res) => {
          that.getClaimItems();
        });
    },
    toDeleteItem: function (uuid) {
      const that = this;
      that
        .$Request({
          method: "POST",
          table: "ess_claim_form_record_items",
          url: "/claim/delete-claim-item/",
          data: {
            claim_form_record_uuid: this.page_params.id,
            uuids: uuid,
          },
        })
        .then((res) => {
          that.$showMessage({
            text: that.$t(
              "message_essweb_myClaimApplication_form_deleteClaimItemSuccessLabel"
            ),
            type: "success",
          });
          that.desserts = that.desserts.filter((ele) => {
            ele.uuid !== uuid;
          });
        });
    },

    toViewItem: function (uuid) {
      this.curUuid = uuid;
      this.showViewClaimItem = true;
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "unknown",
        url: "/approval-task/get-approval-task-details/",
        data: {
          data_type: 2,
          uuid: this.page_params.id,
          is_approval: 1,
        },
      }).then((res) => {
        that.can_be_cancel = Number(res.data.can_it_be_cancelled);
        if (res.data["field_uuid"]) {
          if (res.data["field_uuid"].indexOf(",") != -1) {
            res.data["field_uuid"] = res.data["field_uuid"].split(",");
          } else {
            res.data["field_uuid"] = [res.data["field_uuid"]];
          }
        } else {
          res.data["field_uuid"] = [];
        }
        that.curTypeUuid = res.data.claim_type_uuid;
        that.user = res.data.uuid;
        that.users = [
          {
            staff_avatar: res.data.agent_staff.staff_avatar,
            uuid: res.data.uuid,
            preferred_name: res.data.agent_staff.preferred_name,
          },
        ];
        that.ClaimApplicationData = res.data;
      });
    },
    getClaimBalanceDetail: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_type",
        url: "/claim/get-claim-balance/",
        data: { claim_type_uuid: uuid },
      }).then((res) => {
        that.claim_total_amount = Number(
          res.data["ess_clm_claim_balance"][0]["claim_balance"]
        );
      });
    },
    getClaimItems: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_form_records",
        url: "/claim/get-claim-item-list/",
        data: {
          claim_form_record_uuid: this.page_params.id,
        },
      }).then((res) => {
        that.currency_code = res.data["currency_code"];
        // that.claim_total_amount = Number(res.data["claim_total_amount"]);
        if (res.data["ess_clm_claim_form_record_items"].length)
          res.data["ess_clm_claim_form_record_items"].map((item) => {
            if (item["attachments"])
              item["attachments"].map((item) => {
                item["uuid"] = item["uuid"];
                item["file_name"] = item["file_name"];
                item["path"] = item["url"];
                item["size"] = item["attachment_size"];
              });
          });
        that.desserts = res.data["ess_clm_claim_form_record_items"];
      });
    },
  },
};
</script>
